function Slider() {
  return (
    <div className="flex items-center">
      <div className="w-7 h-7 border bg-white border-black rounded-round"></div>
      <div className="h-1.5 w-24 bg-black"></div>
      <div className="w-8 h-8 relative  border bg-black rounded-round"></div>
      <div className="h-1.5 w-24 rounded-md bg-[#B8BCB5]"></div>
    </div>
  );
}

export default Slider;
